import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, TemplateRef} from '@angular/core';
import {StorageService} from "../../../services/storage.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {SysDataModelFieldService} from "../../../services/system/sys-data-model-field.service";
import * as _ from 'lodash';
import * as moment from 'moment';
import {NzModalService} from "ng-zorro-antd/modal";
import {SysUiDisplayService} from "../../../services/system/sys-ui-display.service";
import {TagService} from "../../../services/tag/tag.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'pi-general-search-tool',
  templateUrl: './general-search-tool.component.html',
  styleUrls: ['./general-search-tool.component.css']
})
export class GeneralSearchToolComponent implements OnInit, OnChanges {
  @ViewChild('searchContent') searchContent;
  @Input() dataModelId: any;
  @Input() mainTemplate: TemplateRef<any>;
  @Input() pageName = 'default';
  @Input() pageCode = 'default';
  @Input() size: 'small' | 'default' | 'large' = 'default';
  @Input() conditionOutputType: 'function' | 'object' = 'function';
  @Output() onSearch = new EventEmitter();
  modelFields: any[] = [];
  searchConditions: any[] = [];
  modelFieldMap: any = {};
  detailForm: FormGroup;
  detailItem: any;
  searchSettings;
  businessType;
  isFilterSet: boolean = false;
  tagCategoryCode;
  selectionList = [];
  constructor(
    private storageService: StorageService,
    private sysDataModelFieldService: SysDataModelFieldService,
    private sysUiDisplayService: SysUiDisplayService,
    private tagService: TagService,
    private modalService: NzModalService,
    private translateService: TranslateService,
    private fb: FormBuilder,
  ) {
    this.businessType = this.storageService.getBusinessTypeItem();
    this.tagCategoryCode = 'STAF'
    const detailItem = this.storageService.getLocalItem('filterCacheItem_' + this.dataModelId);
    if (detailItem) {
      this.detailItem = detailItem;
      this.isFilterSet = true;
    } else {
      this.detailItem = {};
      this.isFilterSet = false;
    }
  }

  ngOnInit(): void {
  }

  async ngOnChanges(changes: SimpleChanges) {
    if (this.dataModelId) {
      this.modelFields = await this.sysDataModelFieldService.getById(this.dataModelId).toPromise();
      this.modelFields.forEach(m => {
        this.modelFieldMap[m.id] = m;
      });
      this.loadData();
      // this.loadSelectionList();
    }
  }

  async loadData() {
    this.businessType = this.storageService.getBusinessTypeItem();
    const dataColumnConfigs = await this.sysUiDisplayService
      .getConfigData(this.businessType, this.dataModelId, 'filter', this.pageName, this.pageCode).toPromise();
    if (dataColumnConfigs && dataColumnConfigs.length > 0) {
      this.searchSettings = dataColumnConfigs[0];
      this.searchConditions = JSON.parse(this.searchSettings.configContent);
    } else {
      this.searchSettings = null;
      this.searchConditions = [];
    }
    this.processData();
  }

  processData() {
    if (this.searchConditions) {
      const formArray = {};
      this.searchConditions.forEach(c => {
        if (c.mode === 'field') {
          if (c.defaultSelectValue) {
            try {
              c.defaultSelection = JSON.parse(c.defaultSelectValue);
            } catch (e) {
              c.defaultSelection = null;
              console.log('ERROR: ', c);
            }
          }
          if (c.defaultSelectApi) {
            this.fetchRemoteData(c);
          }
          formArray[this.modelFieldMap[c.modelFieldId].fieldPropertyName] = [c.defaultValue ? c.defaultValue : null];
        }
        if (c.mode === 'tag') {
          this.fetchRemoteTags(c);
          formArray[c.targetTagFieldName] = [null];
        }
      });
      this.detailForm = this.fb.group(formArray);
      this.detailItem = this.detailForm.getRawValue();
    }
  }

  fetchRemoteData(c) {
    let params = {};
    if (c.apiParams) {
      try {
        params = JSON.parse(c.apiParams);
      } catch (e) {
        console.error('params parse error', e);
      }
    }
    this.sysDataModelFieldService.request('post', c.defaultSelectApi + '/search', params, true).subscribe(res => {
      c.selections = res;
    });
  }

  fetchRemoteTags(c) {
    this.tagService.getTagByTypeCode(c.targetTagTypeCode).subscribe(res => {
      c.selectionList = res;
    });
  }

  getConvertedExpression(expression) {
    switch (expression) {
      case 'lt': return ' < '; break;
      case 'lte': return ' <= '; break;
      case 'gt': return ' > '; break;
      case 'gte': return ' >= '; break;
      case 'equal': return ' == '; break;
      default: return '';
    }
  }

  showFilterModal() {
    const detailItem = this.storageService.getLocalItem('filterCacheItem_' + this.dataModelId);
    if (detailItem) {
      this.detailItem = detailItem;
      this.isFilterSet = true;
    } else {
      this.detailItem = {};
      this.isFilterSet = false;
    }
    const modal = this.modalService.create({
      nzTitle: this.translateService.instant('过滤条件'),
      nzContent: this.searchContent,
      nzStyle: {top: '10px'},
      nzWidth: 800,
      nzOnOk: () => {
        this.getResult();
        this.checkFilterStatus();
        modal.destroy();
      },
      nzOnCancel: () => {
        this.checkFilterStatus();
      }
    })
  }

  checkFilterStatus() {
    for (let key in this.detailItem) {
      if (this.detailItem[key] == null || this.detailItem[key].length === 0) {
        delete this.detailItem[key];
      }
    }
    const keys = Object.keys(this.detailItem);
    if (keys.length === 0) {
      this.detailItem = null;
      this.isFilterSet = false;
    }
  }

  clearFilter() {
    this.storageService.removeLocalItem('filterCacheItem_' + this.dataModelId);
    this.detailItem = {};
    this.isFilterSet = false;
    if (this.conditionOutputType === 'object') {
      this.onSearch.emit({});
    } else {
      const script = `(object) => true`;
      this.onSearch.emit(eval(script));
    }
  }

  getResult() {
    this.storageService.setLocalItem('filterCacheItem_' + this.dataModelId, this.detailItem);
    if (this.conditionOutputType === 'object') {
      const output = _.cloneDeep(this.detailItem);
      for (let key in output) {
        if (_.isDate(output[key])) {
          output[key] = moment(output[key]).utc().format()
        }
      }
      this.onSearch.emit(output);
      return output;
    } else if (this.conditionOutputType === 'function') {
      const resultExpressions = ['true'];
      const activedConditions = this.searchConditions.filter(c => c.switchOn);
      activedConditions.forEach(a => {

        if (a.mode === 'field' && this.modelFieldMap[a.modelFieldId]) {
          const fieldPropertyName = this.modelFieldMap[a.modelFieldId].fieldPropertyName;
          const objectItem = 'object.' + fieldPropertyName;

          if (a.componentType === 'input' && this.detailItem[fieldPropertyName]) {
            resultExpressions.push('(' + objectItem + ' != null && ' + objectItem + '.toUpperCase().indexOf("' + this.detailItem[fieldPropertyName] + '".toUpperCase()) > -1' + ')')
          } else if (a.componentType === 'inputNumber' && this.detailItem[fieldPropertyName] != null && this.detailItem[fieldPropertyName] != '') {
            resultExpressions.push('(' + objectItem + ' != null && ' + objectItem + this.getConvertedExpression(a.logicExpress) + this.detailItem[fieldPropertyName] + ')')
          } else if (a.componentType === 'select' && this.detailItem[fieldPropertyName] != null) {
            if (a.selectMode === 'multiple' && this.detailItem[fieldPropertyName].length > 0) {
              resultExpressions.push('(' + JSON.stringify(this.detailItem[fieldPropertyName]) + '.indexOf(' + objectItem + ') > -1' + ')')
            } else {
              resultExpressions.push('(' + objectItem + ' == "' + this.detailItem[fieldPropertyName] + '")')
            }
          } else if (a.componentType === 'datePicker' && this.detailItem[fieldPropertyName]) {
            if (a.logicExpress !== 'between') {
              resultExpressions.push('(moment(' + objectItem + ').startOf("d").valueOf()' + this.getConvertedExpression(a.logicExpress) +
                moment(this.detailItem[fieldPropertyName]).startOf('d').valueOf() + ')');
            } else {
              resultExpressions.push('(moment(' + objectItem + ').valueOf() >= ' +
                moment(this.detailItem[fieldPropertyName][0]).startOf('d').valueOf() + ' && ' + 'moment(' + objectItem + ').valueOf() <= ' +
                moment(this.detailItem[fieldPropertyName][1]).endOf('d').valueOf() + ')');
            }

          } else if (a.componentType === 'timePicker' && this.detailItem[fieldPropertyName]) {
            if (a.logicExpress !== 'between') {
              resultExpressions.push('(moment(' + objectItem + ').valueOf()' + this.getConvertedExpression(a.logicExpress) +
                moment(this.detailItem[fieldPropertyName]).valueOf() + ')');
            } else {
              resultExpressions.push('(moment(' + objectItem + ').valueOf() >= ' +
                moment(this.detailItem[fieldPropertyName][0]).valueOf() + ' && ' + 'moment(' + objectItem + ').valueOf() <= ' +
              moment(this.detailItem[fieldPropertyName][1]).valueOf() + ')');
            }
          } else if (a.componentType === 'radio' && this.detailItem[fieldPropertyName] != null) {
            resultExpressions.push('(' + objectItem + ' == ' + this.detailItem[fieldPropertyName] + ')');
          }
        } else if (a.mode === 'tag') {
          if (a.componentType === 'tag') {
            if (this.detailItem[a.targetTagFieldName] && this.detailItem[a.targetTagFieldName].length > 0) {
              const objectItem = 'object.' + a.targetTagFieldName;
              const tagIds = this.detailItem[a.targetTagFieldName];
              resultExpressions.push('(' + JSON.stringify(tagIds) + '.filter(t => ' + objectItem + '.includes(t)).length > 0' + ')');
            } else {
              this.detailItem[a.targetTagFieldName] = null;
            }
          }
        }
      });
      const script = `(object) => ${resultExpressions.join(' && ')}`;
      // console.log(script);
      const conditionFunction = eval(script);
      this.onSearch.emit(conditionFunction);
      return conditionFunction;
    }
  }

  public getFilter() {
    return this.getResult();
  }

  checkAllSelections(fieldKey, searchCondition) {
    if (searchCondition.selectDataType === 'manual') {
      this.detailItem[fieldKey] = Array.from(new Set(searchCondition.defaultSelection.map(s => s.value)));
    } else if (searchCondition.selectDataType === 'api') {
      this.detailItem[fieldKey] = Array.from(new Set(searchCondition.selections.map(s => s[searchCondition.selectValue])));
    }
  }

  getOptionLabel(object, label) {
    let result = '';
    if (object && label) {
      const processedLabelFields = label.replace(/，/g, ',').split(',').map(d => d.trim());
      const arr = [];
      processedLabelFields.forEach(l => {
        arr.push(object[l]);
      });
      result = arr.join(' ');
    }
    return result;
  }

}
